import { render, staticRenderFns } from "./FollowDialog.vue?vue&type=template&id=4a2c1348"
import script from "./FollowDialog.vue?vue&type=script&lang=js"
export * from "./FollowDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports